import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	menuLinkItemAriaLabel: {
		id: 'navigation.global-shortcuts.shortcut-link-item.aria-label',
		description: 'Aria label for menu link item',
		defaultMessage: '{appName}{siteName}',
	},
});
